import React from 'react';
import TinySliderLib from 'tiny-slider-react';

export type TinySliderWrapperProps = React.PropsWithChildren<{
    settings: any;
    className?: string;
}>;

export default function TinySliderWrapper({
    settings,
    className,
    children,
}: TinySliderWrapperProps) {
    const Comp = TinySliderLib as unknown as React.ComponentType<any>;

    return React.createElement(Comp, { settings, className }, children);
}
